import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Prelybe</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              Prelybe is a technology and IT solutions company delivering secure, scalable, and practical digital systems for businesses, institutions, and governments. The company specializes in software engineering, IT systems, workflow automation, web and cloud solutions, and digital payment integrations. Prelybe is committed to designing and deploying practical, reliable, and scalable technology systems tailored to real-world operational needs.


            </p>
          </div>
          <div className="about-mission-vision">
            <div className="mission-vision-card">
              <h3 className="mission-vision-title">Vision</h3>
              <p className="mission-vision-text">
                To be a trusted technology partner delivering impactful digital solutions.
              </p>
            </div>
            <div className="mission-vision-card">
              <h3 className="mission-vision-title">Mission</h3>
              <p className="mission-vision-text">
                To design and deploy practical, reliable, and scalable technology systems tailored to real-world needs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

